import { render, staticRenderFns } from "./MyAddressEdit.vue?vue&type=template&id=6d0ad026&"
import script from "./MyAddressEdit.vue?vue&type=script&lang=js&"
export * from "./MyAddressEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports